import { BaseApi } from 'Core/api/BaseApi'

export class Api extends BaseApi {
  getProduct = async ({ slug, locale = 'ME' }) => {
    const defaultResponse = { product: null }

    try {
      const { body } = await Api.get(`/search_product/${slug}?locale=${locale}`, {}, process.env.NEXT_PUBLIC_WEB_SHOP_API_HOST)

      if (body?.product) return body

      return defaultResponse
    } catch (e) {
      defaultResponse.error = e
      return defaultResponse
    }
  }
}